<div ngbDropdown autoClose="outside" class="form-group"
     [class.disableCursor]="isDisabled"
     (openChange)="onDropdownToggle($event)"
>
  <div
    (keydown)="!isDisabled ? keydownOnWrapper($event) : null"
    [class.ds-disabled]="isDisabled"
    [class.disableComboBox]="isDisabled"
    [class.ds-focus]="dropdown.isOpen()"
    [class.ds-filled]="value.length > 0"
    [class.ds-invalid]="showError"
    [tabIndex]="tabIndexDropdownBtn"
    class="form-control__wrapper d-flex flex-nowrap flex-row align-items-stretch"
    ngbDropdownToggle
  >
    <div
      [class.p-1]="multiselect && labelList.length > 0"
      [class.ds-filled]="value.length > 0"
      class="form-control d-flex flex-nowrap form-control--addition"
      [class.multiline]="multiline"
      #comboBoxElement
    >
      <ds-input-label *ngIf="label" [label]="label"></ds-input-label>

      <ng-container *ngIf="multiselect; else singleSelectBlock">
        <ng-container *ngIf="!visibleLabelList; else blueBadge">
          <div
            *ngFor="let labelEntry of labelList"
            class="ds-combo-box-badge flex-shrink-0 align-self-center me-1"
          >
            <span class="me-1">{{ labelEntry }}</span>
            <span
              class="ds-icon ds-icon--small ds-icon--close remove-label"
              (click)="removeLabelEntry($event, labelEntry)"
            ></span>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #singleSelectBlock>
        <ng-container *ngIf="labelList.length > 0">
          <ng-container *ngIf="selectedHtml; else textContainer">
            <div class="ds-input__text" [innerHTML]="selectedHtml"></div>
          </ng-container>
          <ng-template #textContainer>
            <div class="ds-input__text" [innerHTML]="labelList[0]"></div>
          </ng-template>
        </ng-container>
      </ng-template>

      <ng-template #blueBadge>
        <div
          *ngFor="let labelEntry of visibleLabelList"
          class="ds-combo-box-badge flex-shrink-0 align-self-center me-1">
          <span class="me-1">{{ labelEntry }}</span>
          <span
            class="ds-icon ds-icon--small ds-icon--close remove-label"
            (click)="removeLabelEntry($event, labelEntry)"
          ></span>
        </div>
        <div class="ds-combo-box-badge-blue flex-shrink-0 align-self-center">
          <span>{{ blueTagLabel(visibleLabelList) }}</span>
        </div>
      </ng-template>

      <ds-input-placeholder
        *ngIf="labelList.length === 0"
        [placeholder]="label"
      ></ds-input-placeholder>
    </div>
    <ds-input-icon
      [iconName]="dropdown.isOpen() ? 'arrow-up' : 'arrow-down'"
    ></ds-input-icon>
  </div>

  <div ngbDropdownMenu>
    <ng-content></ng-content>
  </div>
</div>
<ds-input-error [error]="error" [showError]="showError"></ds-input-error>
